import React from "react";
import { useFilters } from "hooks/useStore";

const PaginationRange = ({ handle }) => {
	const { collections } = useFilters(["collections"]);
	const pageDetails = collections[handle]?.pageDetails || {};

	return (
		<div className="text-secondary text-xs md:text-base text-center lg:text-left flex gap-1">
			<span className="hidden md:block">Showing</span>
			<span>
				{pageDetails.showing?.start}
			</span>
			<span>
				{"- "}
				{pageDetails.showing?.end}
			</span>
			<span>of {pageDetails.totalResults} results</span>
		</div>
	);
};

export default PaginationRange;